<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode" ></ParseForm>
      </template>
    </div>
  </div>
</template>

<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ajaxUrl from "../../../data/ajaxUrl";
import { EventBus } from "../../../../../plugins/eventBus";

export default {
  name: "AddBatchPuiForm",
  components: {
    ParseForm,
  }, 
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return false;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      console.log(map);
      return map;
    },
    getJson(ne, callback) {
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.addpuiBatchJsonReq, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, []);
        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        callback(response);
      });      
    },
     responseIsFailed(response) {
      if (!response) {
        console.log("response error");
        return true;
      }
      if (!response.data) {
        console.log("response.data error");
        return true;
      }
      if (!response.data.resultVal) {
        console.log("response.data.resultVal error");
        return true;
      }
      if (0 !== response.data.resultVal.result) {
        EventBus.$emit("toast", {
          type: "warning",
          content: response.data.errorString
        });
        return true;
      }
      return false;
    },
    async saveBatchUser(ne, callback) {
      const formData = this.getDatas();
      if (formData) { 
        const cfuStatus=formData.get("cfuStatus");
        const cfuPui=formData.get("cfuPui");
        const cfbStatus=formData.get("cfbStatus");
        const cfbPui=formData.get("cfbPui");
        const cfnrStatus=formData.get("cfnrStatus");
        const cfnrPui=formData.get("cfnrPui");
        const cfnlStatus=formData.get("cfnlStatus");
        const cfnlPui=formData.get("cfnlPui");
        if((cfuStatus==1||cfuStatus==2)&&cfuPui==""){
            EventBus.$emit('toast', {type: 'warning', content: this.$t("Pui.cfuPuiNull")});
            return false
        }
        if((cfbStatus==1||cfbStatus==2)&&cfbPui==""){
            EventBus.$emit('toast', {type: 'warning', content: this.$t("Pui.cfbPuiNull")});
            return false
        }
        if((cfnrStatus==1||cfnrStatus==2)&&cfnrPui==""){
            EventBus.$emit('toast', {type: 'warning', content: this.$t("Pui.cfnrPuiNull")});
            return false
        }
        if((cfnlStatus==1||cfnlStatus==2)&&cfnlPui==""){
            EventBus.$emit('toast', {type: 'warning', content: this.$t("Pui.cfnlPuiNull")});
            return false
        }


      const startPui = formData.get("startPUI");
      const opCount = formData.get("count");
      const addPuiList = [];      
      let puiNum = 0
      let puiNumStr = "";
      let puiNumEnd = "";
      for(let i=0;i<opCount;i++){
        let placeNumStart=0;
        let placeNumEnd=0;
        let isNotNumber=false;
        for(let j = 0; j < startPui.length; j++){
          if(startPui[j].match(/\d/)&&!isNotNumber){
             placeNumStart=j;
             isNotNumber=true;
          }else if(!(startPui[j].match(/\d/))&&isNotNumber){
            placeNumEnd=j;
            break;//后续还有数字的情况
          }
        }
        if(placeNumEnd==0){//数字是结尾的情况
          placeNumEnd=startPui.length;
        }
        let puiNumber=startPui.substr(placeNumStart, placeNumEnd-placeNumStart);
        let datai=(Number(puiNumber) + i).toString();
        const newData=startPui.substr(0, placeNumStart)+datai+startPui.substr(placeNumEnd, startPui.length)
        if(0==i){
          puiNum=puiNumber;
          puiNumStr=placeNumStart;
          puiNumEnd=placeNumEnd;
        }
        addPuiList.push({
          pui: newData
        });
      }
        this.sendAddPuiList = addPuiList;
        const startPVI = formData.get("startPVI");
        let startPviNum =startPVI.split("@")[0];
        let startPviStr =startPVI.split("@")[1];
        let puiEvery100 = puiNum;
        let pviEvery100 = startPviNum;
        let countAll = parseInt(formData.get("count"));
        let numAxios = parseInt(countAll / 100); //取整
        let numAxiosLast = countAll % 100; //取余数
        let countEach = 100;  
        if (numAxios > 0) {
          if (numAxiosLast == 0) {
            //整数
            for (let i = 0; i < numAxios; i++) {
              
              let paramsEach = {
                vo: {
            "count": 100,
            "startPUI":startPui.substr(0, puiNumStr)+(Number(puiNum) + i*100).toString()+startPui.substr(puiNumEnd, startPui.length),
            "startPVI":  parseInt(pviEvery100) + i * 100 +"@"+ startPviStr,
            "oipStatus": formData.get("oipStatus"),
            "oipOverride": formData.get("oipOverride"),
            "oirStatus": formData.get("oirStatus"),
            "oirMode": formData.get("oirMode"),
            "oirTemporarySet": formData.get("oirTemporarySet"),
            "oirRestrictMode": formData.get("oirRestrictMode"),
            "cfuStatus": formData.get("cfuStatus"),
            "cfuPui": formData.get("cfuPui"),
            "cfbStatus": formData.get("cfbStatus"),
            "cfbPui": formData.get("cfbPui"),
            "cfnrStatus": formData.get("cfnrStatus"),
            "cfnrPui": formData.get("cfnrPui"),
            "cfnrTime": parseInt(formData.get("cfnrTime")),
            "cfnlStatus": formData.get("cfnlStatus"),
            "cfnlPui": formData.get("cfnlPui"),
            "cfnrcStatus": formData.get("cfnrcStatus"),
            "cfnrcPui": formData.get("cfnrcPui"),
            "cwStatus": formData.get("cwStatus"),
            "cwNotify": formData.get("cwNotify"),
            "holdStatus": formData.get("holdStatus"),
            "ocbStatus": formData.get("ocbStatus"),
            "icbStatus": formData.get("icbStatus"),
            "thirdPartyStatus": formData.get("thirdPartyStatus"),
            "confStatus": formData.get("confStatus"),
                },
                info: {
                  msgid: this.msgId,
                  neid: ne.neid,
                }
              };

              await this.$axios
                .post(ajaxUrl.requestCommonD, paramsEach)
                .then(response => {
                  if (this.responseIsFailed(response)) {
                    this.$loading.hideLoadding();
                    return;
                  }

                  this.resultValAll = this.resultValAll.concat(
                    response.data.resultVal.resultCode
                  );
                  this.resultCodeStr = this.resultCodeStr.concat(
                    response.data.resultVal.resultCodeStr
                  );
                  if (i == numAxios - 1) {
                    response.data.resultVal.resultCode = this.resultValAll;
                    response.data.resultVal.resultCodeStr = this.resultCodeStr;

                    callback(response, this.sendAddPuiList);
                  }
                });
            }
          } else {
            for (let i = 0; i <= numAxios; i++) {
              if (i == numAxios && numAxios > 0 && numAxiosLast != 0) {
                countEach = countAll - numAxios * 100; //整数部分下发后剩余部分下发
              }
              let paramsEach = {
                vo: {
            "count": countEach,
            "startPUI":startPui.substr(0, puiNumStr)+(Number(puiNum) + i*100).toString()+startPui.substr(puiNumEnd, startPui.length),
            "startPVI":  parseInt(pviEvery100) + i * 100 +"@"+ startPviStr,
            "oipStatus": formData.get("oipStatus"),
            "oipOverride": formData.get("oipOverride"),
            "oirStatus": formData.get("oirStatus"),
            "oirMode": formData.get("oirMode"),
            "oirTemporarySet": formData.get("oirTemporarySet"),
            "oirRestrictMode": formData.get("oirRestrictMode"),
            "cfuStatus": formData.get("cfuStatus"),
            "cfuPui": formData.get("cfuPui"),
            "cfbStatus": formData.get("cfbStatus"),
            "cfbPui": formData.get("cfbPui"),
            "cfnrStatus": formData.get("cfnrStatus"),
            "cfnrPui": formData.get("cfnrPui"),
            "cfnrTime": parseInt(formData.get("cfnrTime")),
            "cfnlStatus": formData.get("cfnlStatus"),
            "cfnlPui": formData.get("cfnlPui"),
            "cfnrcStatus": formData.get("cfnrcStatus"),
            "cfnrcPui": formData.get("cfnrcPui"),
            "cwStatus": formData.get("cwStatus"),
            "cwNotify": formData.get("cwNotify"),
            "holdStatus": formData.get("holdStatus"),
            "ocbStatus": formData.get("ocbStatus"),
            "icbStatus": formData.get("icbStatus"),
            "thirdPartyStatus": formData.get("thirdPartyStatus"),
            "confStatus": formData.get("confStatus"),
                },
                info: {
                  msgid: this.msgId,
                  neid: ne.neid,
                }
              };
              await this.$axios
                .post(ajaxUrl.requestCommonD, paramsEach)
                .then(response => {
                  if (this.responseIsFailed(response)) {
                    this.$loading.hideLoadding();
                    return;
                  }
                  this.resultValAll = this.resultValAll.concat(
                    response.data.resultVal.resultCode
                  );
                  this.resultCodeStr = this.resultCodeStr.concat(
                    response.data.resultVal.resultCodeStr
                  );

                  if (i == numAxios) {
                    response.data.resultVal.resultCode = this.resultValAll;
                    response.data.resultVal.resultCodeStr = this.resultCodeStr;

                    callback(response, this.sendAddPuiList);
                  }
                });
            }
          }
        } else if (numAxios == 0 && numAxiosLast != 0) { //没有整数部分即不到100，全下发
        const params = { 
          vo: {    
            "startPUI": formData.get("startPUI"),
            "startPVI": formData.get("startPVI"),
            "count": parseInt(formData.get("count")),
            "oipStatus": formData.get("oipStatus"),
            "oipOverride": formData.get("oipOverride"),
            "oirStatus": formData.get("oirStatus"),
            "oirMode": formData.get("oirMode"),
            "oirTemporarySet": formData.get("oirTemporarySet"),
            "oirRestrictMode": formData.get("oirRestrictMode"),
            "cfuStatus": formData.get("cfuStatus"),
            "cfuPui": formData.get("cfuPui"),
            "cfbStatus": formData.get("cfbStatus"),
            "cfbPui": formData.get("cfbPui"),
            "cfnrStatus": formData.get("cfnrStatus"),
            "cfnrPui": formData.get("cfnrPui"),
            "cfnrTime": parseInt(formData.get("cfnrTime")),
            "cfnlStatus": formData.get("cfnlStatus"),
            "cfnlPui": formData.get("cfnlPui"),
            "cfnrcStatus": formData.get("cfnrcStatus"),
            "cfnrcPui": formData.get("cfnrcPui"),
            "cwStatus": formData.get("cwStatus"),
            "cwNotify": formData.get("cwNotify"),
            "holdStatus": formData.get("holdStatus"),
            "ocbStatus": formData.get("ocbStatus"),
            "icbStatus": formData.get("icbStatus"),
            "thirdPartyStatus": formData.get("thirdPartyStatus"),
            "confStatus": formData.get("confStatus"),
          }, 
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          }
        };
        console.log("addPuiList",addPuiList)
        this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => { 
          if (callback) {
            callback(response,addPuiList);
          }
        });}
      } 
      else{
        this.$loading.hideLoadding();
      }
    }, 
  },
  computed: {

  },
  data() {
    return {
      ne: null,
      id: 0,
      funcMap: null,
      list: [ 
      ],
      formItems: {
        basic: {
          formId: "PuiAddBatchBasicInfo",
          modelName: "basic",
          formObj: null,
        },
      }, 
      opCode: "add",
      msgId: "30484",
      timer1: null,
      resultValAll: [],
      resultCodeStr: [],
      sendAddPuiList: []
    };
  },
  beforeDestroy() {
  }
};
</script>
